if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector(
          '[type="submit"], .ito_atc__button'
        );

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        let flagProductPage = true;
        window.location.href.split("/").forEach((segment, index) => {
          if (segment === "products") {
            flagProductPage = false;
          }
        });
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        if (!this.validateVariantSelection()) return;

        this.handleErrorMessage();
        if (!flagProductPage) {
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");
          this.querySelector(".loading__spinner").classList.remove("hidden");
          this.querySelector(".atc__text")?.classList.add("zoomout");
          this.querySelector(".atc__text")?.classList.remove("fadeInDown");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status == 422 && flagProductPage) {
              this.handleErrorMessage(response.description);
              return;
            }
            if (flagProductPage) {
              setTimeout(() => {
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.classList.add("loading");
                this.querySelector(".loading__spinner").classList.remove(
                  "hidden"
                );
                this.querySelector(".atc__text")?.classList.add("zoomout");
                this.querySelector(".atc__text")?.classList.remove(
                  "fadeInDown"
                );
              }, 10);
              setTimeout(() => {
                this.submitButton.setAttribute("aria-disabled", false);
                this.submitButton.classList.remove("loading");
                this.querySelector(".loading__spinner").classList.add("hidden");
                this.querySelector(".atc__text")?.classList.remove("zoomout");
                this.querySelector(".atc__text")?.classList.add("fadeInDown");
                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(response.description);

                  const soldOutMessage =
                    this.submitButton.querySelector(".sold-out-message");
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute("aria-disabled", true);
                  this.submitButton
                    .querySelector("span")
                    .classList.add("hidden");
                  soldOutMessage.classList.remove("hidden");
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    cartData: response,
                  });
                this.error = false;
                const quickAddModal = this.closest("quick-add-modal");
                if (quickAddModal) {
                  document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(response);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }
                document.dispatchEvent(new Event("ProductAdded"));

              }, 20);
            }
            else {

              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
              document.dispatchEvent(new Event("ProductAdded"));
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
            this.querySelector(".atc__text").classList.add("fadeInDown");
          });
      }

      // Button-style variant pickers (<variant-radios>) never pre-check a radio, and
      // sit outside this element's own form (their inputs link back to it only via
      // the HTML `form="..."` attribute), so querying this.form doesn't see them.
      // Look the picker up by the section id both elements already carry instead.
      validateVariantSelection() {
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return true;

        const variantRadios = document.getElementById(
          `variant-radios-${sectionId}`
        );
        if (!variantRadios) return true;

        const missingOptionNames = [];
        let hasMissingOption = false;

        variantRadios
          .querySelectorAll("fieldset.product-form__input")
          .forEach((fieldset) => {
            const radios = fieldset.querySelectorAll('input[type="radio"]');
            if (radios.length === 0) return;

            const warning = fieldset.querySelector(".option_warning");
            const hasSelection = Array.from(radios).some(
              (radio) => radio.checked
            );

            if (hasSelection) {
              if (warning) warning.style.display = "none";
              return;
            }

            const legend = fieldset.querySelector("legend[data-title]");
            missingOptionNames.push(
              legend ? legend.getAttribute("data-title") : "an option"
            );
            if (warning) warning.style.display = "block";
            hasMissingOption = true;

            if (!fieldset.dataset.validationBound) {
              fieldset.dataset.validationBound = "true";
              radios.forEach((radio) =>
                radio.addEventListener("change", () => {
                  if (warning) warning.style.display = "none";
                  // Garment PDP sticky bar: picking a size no longer closes
                  // the revealed swatches by itself - they stay open until
                  // the shopper taps the close arrow (or scrolls the bar
                  // out of its sticky state), see
                  // sections/main-product-garment-pdp.liquid.
                })
              );
            }
          });

        if (missingOptionNames.length === 0) return true;

        // Garment PDP: tapping Add to Cart from the sticky bar with no size
        // selected reveals the swatches inside the sticky bar itself (see
        // sections/main-product-garment-pdp.liquid) instead of showing the
        // error immediately - only on the first attempt; if __revealStickySwatches
        // returns false (already revealed, or not applicable - function
        // only exists on Garment PDP, and only intercepts while the bar is
        // actually sticky), fall through to the normal error below. Moves
        // the whole <variant-radios> element (not just a fieldset) so its
        // own internal "change" listener - bound once in its constructor,
        // which doesn't re-run on a DOM move - keeps working from its new
        // spot: that listener relies on the radios still being its
        // descendants, which only holds if the fieldset moves as part of
        // the custom element, not away from it.
        if (
          hasMissingOption &&
          typeof window.__revealStickySwatches === "function" &&
          window.__revealStickySwatches(variantRadios)
        ) {
          return false;
        }

        this.handleErrorMessage(
          `Please select a ${missingOptionNames.join(" and ")} before adding to cart.`
        );

        // Auto-dismiss after a few seconds instead of sitting there until a
        // size is picked - on the sticky bar in particular, this error sits
        // right over the newly-revealed swatches and was blocking the
        // shopper from even seeing or tapping them.
        if (this.missingOptionErrorTimeout) {
          clearTimeout(this.missingOptionErrorTimeout);
        }
        this.missingOptionErrorTimeout = setTimeout(() => {
          this.handleErrorMessage();
          this.missingOptionErrorTimeout = null;
        }, 4000);

        return false;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          const errorMessageSpan = document.querySelector(
            "span.product-form__error-message.getMSG_err_pro"
          );
          if (errorMessageSpan) {
            errorMessageSpan.textContent = errorMessage;

            if (screen.width < 600) {
              var targetScrollPosition = errorMessageSpan.offsetTop + 900;
              var startTime = null;
              var duration = 300;

              function animateScroll(currentTime) {
                if (startTime === null) {
                  startTime = currentTime;
                }

                var elapsed = currentTime - startTime;
                var progress = Math.min(elapsed / duration, 1);

                function easeInOutQuad(t) {
                  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
                }

                var newPos =
                  easeInOutQuad(progress) *
                  (targetScrollPosition - window.scrollY) +
                  window.scrollY;

                document.documentElement.scrollTop = newPos;
                document.body.scrollTop = newPos;

                if (progress < 1) {
                  requestAnimationFrame(animateScroll);
                }
              }
            }
          }

          const customErrorMessage = document.querySelector(
            ".custom_new_errMsg2"
          );
          if (customErrorMessage) {
            customErrorMessage.classList.remove("hidden");
          }
        } 
      }
    }
  );
}
